export default function NoPage() {
  return (
    <div className="main_basket">
      <h1>Error 404</h1>
      <p>
        The page that you are trying looking for is NOT found in this server
      </p>
    </div>
  );
}
